import { GET_RESERVATION_CONFIRMATION_RESPONSE, GET_RESERVATION_CONFIRMATION } from './constants'
import { LOGOUT } from 'auth/constants'

const initialState = {
    parkingPassUrl: null,
    parkingPassRequirements: null,
}

export default function reducer(state = initialState, action) {
    const { type } = action

    switch (type) {
        case GET_RESERVATION_CONFIRMATION_RESPONSE:
            return {
                ...state,
                parkingPassUrl: action.parkingPassUrl,
                parkingPassRequirements: action.parkingPassRequirements,
            }
        case GET_RESERVATION_CONFIRMATION:
            return {
                ...state,
                confirmationNumber: action.confirmationNumber,
                orderEmailAddress: action.orderEmailAddress,
            }

        case LOGOUT:
            return initialState

        default:
            return state
    }
}
